export enum AttributesIdMap {
  mandatory = "mandatory",
  required = "required",
  optional = "optional",
}
